<div class="modal-body">
  <div class="modal-header-wrapper">
    <h2 class="title-text">Envoyer un questionnaire <b>{{name}}</b></h2>
  </div>
  <div id="modal-content-wrapper">
    <div id="quiz-form" class="form-field">
      <label>Questionnaire</label>
      <select [class.is-invalid]="surveyInvalid" class="form-control custom-select"
              id="quiz-select" [(ngModel)]="currentTemplate">
        <option [ngValue]="undefined" value="" selected disabled>Choisir un questionnaire...</option>
        <option *ngFor="let q of templates" [ngValue]="q">{{q.name}}</option>
      </select>
      <div *ngIf="surveyInvalid" class="invalid-feedback">
        Veuillez entrer un type valide.
      </div>
    </div>
    <h4>Le nom du questionnaire sera visible pour vos patients en sujet de conversation ou de message électronique.</h4>
    <h3 class="subtitle-text">Message associé au questionnaire</h3>
    <div id="message-form" class="form-field">
      <msd-message-editor (changeMessageTemplate)="onChangeMessageTemplate($event)"
                          (deleteMessageTemplate)="onDeleteMessageTemplate($event)"
                          (invalidMessageTemplate)="invalidMessageTemplate = $event"
                          [maxRows]="8"
                          [minRows]="3"
                          [visible]="true"
                          [type]="'survey'">
      </msd-message-editor>
    </div>

    <div id="scheduled-date-wrapper">
      <div class="form-check form-switch">
        <input class="form-check-input" [(ngModel)]="isScheduled" type="checkbox" id="scheduled-switch">
        <label class="form-check-label" for="scheduled-switch">Programmer la date et l’heure de l'envoi</label>
      </div>
    </div>
    <div id="scheduled-date-selector-wrapper" *ngIf="isScheduled">
      <div id="date-wrapper">
        <label>Date</label>
        <input id="date-input" [(ngModel)]="scheduledDate" type="text" placeholder="Choisissez une date"
               class="form-control" [bsConfig]="{ containerClass: 'theme-blue', adaptivePosition: true }"
               bsDatepicker>
      </div>

      <div id="hour-wrapper">
        <label>Heure</label>
        <input id="hour-input" [(ngModel)]="scheduledTime" type="time" placeholder="Choisissez une heure"
               class="form-control">
      </div>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button id="cancel-button" (click)="hideModal()" type="button"
          class="btn btn-outline-primary btn-outline text-only">
    Annuler
  </button>

  <button id="validate-button" (click)="sendSurvey()" [disabled]="surveyInvalid || isLoading || !enableScheduling()"
          type="button" class="btn btn-primary btn-gradient">
    <ng-container *ngIf="isLoading; else sendButton">
      <span class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
      <span class="visually-hidden">Chargement...</span>
    </ng-container>
    <ng-template #sendButton>
      Envoyer
    </ng-template>
  </button>
</div>
